module.exports = __webpack_public_path__ + "img/settings/Level3.126547.svg";